import { PaymentMethodUiType } from '../virtual-terminal/components/payment-entry/payment-entry-model';

export class ValidationHelper {
	static validateEmailAddress(address: string): boolean {
		/* tslint:disable max-line-length */
		// Regex copied from jquery.validate
		const emailAddresRegex: RegExp = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
		/* tslint:enable max-line-length */
		return emailAddresRegex.test(address);
	}

	static looksLikeCreditCard(value: string): boolean {
		//please keep me updated along with fastpay, fastbill, loggedinweb, merchant portal and webgiving
		const creditCardRegex = /([2-6](\d[ \-]*){11,18})/i;
		return creditCardRegex.test(value);
	}

	//See PaymentMethodTypesAndPaymentMaxLimitEligibility in PaymentAmountValidatorTests.cs
	static paymentMethodTypeHasMaxAmountLimit(payMethodUiType: PaymentMethodUiType) : boolean {
		const paymentMethodTypesUsingMaxAmountLimit = [
			PaymentMethodUiType.CreditCard,
			PaymentMethodUiType.ExistingCreditCard,
			PaymentMethodUiType.ACH,
			PaymentMethodUiType.ExistingACH
		];
		return paymentMethodTypesUsingMaxAmountLimit.some(x => x === payMethodUiType);
	}
}
